import RootState from './RootState';
import {
  Module,
  ActionTree,
  ActionContext,
  GetterTree,
  MutationTree,
} from 'vuex';
// @ts-ignore
import querystring from 'querystring';
import { SystemMessage } from '../shared';

export enum NotificationType {
  Success,
  Warning,
  Error,
  Info,
}

export interface NotificationState {
  type: string;
  message: string;
}

// @ts-ignore
export const state: NotificationState = {
  type: 'success',
  message: '',
};

export const actions: ActionTree<NotificationState, RootState> = {
  showMessage(
    context: ActionContext<NotificationState, RootState>,
    message: SystemMessage,
  ) {
    context.commit('setMessage', message);
  },
};

export const getters: GetterTree<NotificationState, RootState> = {
  message(state: NotificationState): string {
    return state.message;
  },
};

export const mutations: MutationTree<NotificationState> = {
  setMessage(state: NotificationState, message: SystemMessage) {
    state.type = message.color;
    state.message = message.message;
  },
};

export const notification: Module<NotificationState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
